import React from 'react';
import styles from './Assets.module.css';
import defaultAvatar from '../../assets/default-avatar.png';
import minoNFT from './mino-nft.png';
import useStore from '../../../../hooks/useStore';
import { showToast } from '../../../../utils/toast';

import I_NFT from './I_NFT.png';
import L_NFT from './L_NFT.png';
import O_NFT from './O_NFT.png';
import T_NFT from './T_NFT.png';

const TETROMINO_IMAGES = {
    I: I_NFT,
    L: L_NFT,
    T: T_NFT,
    O: O_NFT
};

const TETROMINO_ORDER = ['L', 'I', 'T', 'O'];

const getTetrominoByIndex = (index) => {
    const type = TETROMINO_ORDER[index % TETROMINO_ORDER.length];
    return {
        type,
        image: TETROMINO_IMAGES[type]
    };
};

const TetrominoNFT = ({ type, image, count = 1 }) => {
    return (
        <div className={styles.tetrominoNFT}>
            <img 
                src={image} 
                alt={`Tetromino - ${type}`} 
                className={styles.tetrominoImage}
            />
            <div className={styles.nftInfo}>
                <span className={styles.nftName}>Tetromino - {type} <span className={styles.nftCount}>x{count}</span></span>
            </div>
        </div>
    );
};

const Assets = () => {
    const { 
        address,
        userStatus
    } = useStore();

    const { 
        is_checked_in: hasNFT, 
        referral_count: totalReferred
    } = userStatus;

    const initialBonus = 30000;
    const tetrominoBonus = Math.floor(totalReferred / 4) * 30000;
    const directReferralBonus = totalReferred * 15000;
    const minoEarning = initialBonus + tetrominoBonus + directReferralBonus;
    const formattedMinoEarning = minoEarning.toLocaleString();
    
    const formattedTetrominoBonus = tetrominoBonus.toLocaleString();
    const formattedReferralBonus = directReferralBonus.toLocaleString();
    const formattedInitialBonus = initialBonus.toLocaleString();
    
    const tetrominoCount = Math.floor(totalReferred / 4);
    
    const tetrominoCounts = {};
    for (let i = 0; i < tetrominoCount; i++) {
        const type = TETROMINO_ORDER[i % TETROMINO_ORDER.length];
        tetrominoCounts[type] = (tetrominoCounts[type] || 0) + 1;
    }
    
    const uniqueTetrominos = [];
    for (let i = 0; i < Math.min(tetrominoCount, TETROMINO_ORDER.length); i++) {
        const type = TETROMINO_ORDER[i % TETROMINO_ORDER.length];
        if (uniqueTetrominos.some(t => t.type === type)) continue;
        
        const tetromino = getTetrominoByIndex(i);
        tetromino.count = tetrominoCounts[type];
        uniqueTetrominos.push(tetromino);
    }

    const handleClaimClick = () => {
        showToast.warning("You will be able to claim tokens after launch");
    };

    if (!address) {
        return (
            <div className={styles.emptyState}>
                <p className={styles.noNftsText}>Please connect your wallet to view assets</p>
            </div>
        );
    }

    return (
        <div className={styles.assetsContainer}>
            <div className={styles.earningSection}>
                <div className={styles.earningInfo}>
                    <h3 className={styles.earningTitle}>$MINO Earning</h3>
                    <p className={styles.earningAmount}>{formattedMinoEarning}</p>
                    <p className={styles.earningRate}>Tetromino Bonus: {formattedTetrominoBonus} $MINO</p>
                    <p className={styles.earningRate}>Referral Bonus: {formattedReferralBonus} $MINO</p>
                </div>
                <button 
                    className={styles.claimButton} 
                    onClick={handleClaimClick}
                >
                    Claim
                </button>
            </div>
            <div className={styles.nftSection}>
                <span className={styles.nftTitle}>NFTs</span>
                {!hasNFT ? (
                    <div className={styles.emptyState}>
                        <img src={defaultAvatar} alt="Default Avatar" className={styles.defaultAvatar} />
                        <p className={styles.noNftsText}>No NFTs found</p>
                        <p className={styles.helpText}>Mint your first Mino NFT on the Referral tab!</p>
                    </div>
                ) : (
                    <>
                        <div className={styles.nftGrid}>
                            <div className={styles.nftCard}>
                                <img src={minoNFT || defaultAvatar} alt="Your Mino NFT" className={styles.nftImage} />
                                <div className={styles.nftInfo}>
                                    <span className={styles.nftName}>Mino Avatar NFT <span className={styles.nftCount}>x1</span></span>
                                </div>
                            </div>
                            
                            {uniqueTetrominos.map((tetromino, index) => (
                                <div key={index} className={styles.nftCard}>
                                    <TetrominoNFT {...tetromino} />
                                </div>
                            ))}
                            
                            {tetrominoCount === 0 ? (
                                <>
                                    <div className={styles.nftPlaceholder}>
                                        <p>Get 4 referrals to unlock</p>
                                    </div>
                                    <div className={styles.nftPlaceholder}>
                                        <p>Get 8 referrals to unlock</p>
                                    </div>
                                    <div className={styles.nftPlaceholder}>
                                        <p>Get 12 referrals to unlock</p>
                                    </div>
                                </>
                            ) : (
                                [...Array(Math.max(0, 3 - uniqueTetrominos.length))].map((_, index) => (
                                    <div key={`placeholder-${index}`} className={styles.nftPlaceholder}>
                                        <p>Get {(uniqueTetrominos.length + index + 1) * 4} referrals to unlock</p>
                                    </div>
                                ))
                            )}
                        </div>
                        <div className={styles.nftDescription}>
                            <p>You've earned {tetrominoCount} Tetromino NFTs with {totalReferred} referrals.</p>
                            <p>Get {4 - (totalReferred % 4)} more referrals to earn your next Tetromino NFT!</p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Assets;

